import { Fancybox, Panzoom } from "@fancyapps/ui";
import * as bootstrap from "bootstrap";

function debounce(func, delay) {
    let timeoutId;
    return function(...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func(...args);
        }, delay);
    };
}

// oilib.js needs bootstrap to be available on the window object. It uses bootstrap popovers (maybe others, too).
window.bootstrap = bootstrap;

// Trigger Tabs By Hash
var triggerTabList = [].slice.call(document.querySelectorAll(".tab-btn"));

triggerTabList.forEach(function(triggerEl) {
    var tabTrigger = new bootstrap.Tab(triggerEl);
    var hash = "#" + triggerEl.href.split("#")[1];
    var tabBtn = document.querySelector(hash + "-tab");

    triggerEl.addEventListener("click", function(event) {
        event.preventDefault();
        tabBtn.click();
    });
});

// Panzoom

const panzoom = document.querySelector(".panzoom");
const panzoom_reset = document.querySelector(".panzoom-reset");
const panZoomImg = document.querySelector(".panzoom__content");
const fpImgLink = document.querySelectorAll("[data-imgurl]");

if (panzoom != "undefined" && panzoom != null) {
    const myPanzoom = new Panzoom(panzoom, {
        minScale: 0.5,
        maxScale: 3,
    });
    panzoom_reset.addEventListener("click", function(event) {
        myPanzoom.zoomTo(1);
    });
}

for (const link of fpImgLink) {
    link.addEventListener("click", () => {
        fpImgLink.forEach((e) => {
            e.classList.remove("active-bg");
        });
        link.classList.add("active-bg");
        var imgUrl = link.dataset.imgurl;
        panZoomImg.src = imgUrl;
    });
}

// Fancybox

// Tracks fancybox image views.
let fancyboxEventBlock = false;

/** Abstracted event action handler
 * @param {import("@fancyapps/ui").Fancybox} fancybox
 */
const doFancyboxOiEvent = (fancybox) => {
    if (fancybox.options.trigger.dataset.oiEventName) {
        let oi_event_name = fancybox.options.trigger.dataset.oiEventName;
        if ("undefined" != typeof window.dataLayer) {
            window.dataLayer.push({ event: oi_event_name });
        }
        if ("undefined" != typeof window.hfaDataLayer) {
            window.hfaDataLayer.push({ event: oi_event_name });
        }
    }
};

// Bind actions to Fancybox events
Fancybox.bind("[data-fancybox]", {
    on: {
        initCarousel: (fancybox) => {
            if (!fancyboxEventBlock) {
                // Block additional Fancybox events
                fancyboxEventBlock = true;
                // Do Fancybox event
                doFancyboxOiEvent(fancybox);
                // Undo the event block after 1 second.
                setTimeout(() => {
                    fancyboxEventBlock = false;
                }, 1000);
            }
        },
        done: (fancybox, slide) => {
            if (!fancyboxEventBlock) {
                doFancyboxOiEvent(fancybox);
            }
        },
        destroy: () => {
            // Reset the block on Fancybox close.
            fancyboxEventBlock = false;
        },
    },
});

// Fire oi.utils function to wrap all iframes contained in WYSIWYG editors with oi-aspect classes
window.addEventListener(
    "load",
    function() {
        oi.utils.wrap_oi_aspect();
    },
    false,
);

// Focus the search input when the Search Modal is shown
const modalSearch = document.getElementById("modal-search");
modalSearch.addEventListener("shown.bs.modal", () => {
    document.getElementById("site-search").focus();
});

const siteNavWrap = document.getElementById('site-nav-wrap');
const siteNav = document.getElementById('site-nav');

// Set page scroll padding based on height of main nav
function updateScrollPadding(height) {
    let navHeight = height ? height : siteNavWrap.getBoundingClientRect().height;
    let scrollPadding = navHeight;
    const subnav = document.querySelector('.navbar-subnav');
    if (subnav && window.innerWidth >= (992 + 15)) {
        // Add subnav height if subnav exists and we're above lg breakpoint (where subnav becomes sticky)
        scrollPadding += subnav.getBoundingClientRect().height;
    }
    scrollPadding += 32; // Extra space
    document.querySelector("html").style.scrollPaddingTop = `${scrollPadding}px`;
}

// Set page top padding based on height of main nav
function updateBodyPadding(height) {
    let navHeight = height ? height : siteNavWrap.getBoundingClientRect().height;
    let padding = navHeight;
    document.querySelector('body').style.paddingTop = `${padding}px`;
}

// Update the height of the main nav in CSS variable for meganav position
function checkNavHeight() {
    let navHeight = siteNavWrap.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--nav-height', `${navHeight}px`);
    updateScrollPadding(navHeight);
    updateBodyPadding(navHeight);
}

// Apply scrolling size effect to nav and check nav height
function handleNavScrollSizing() {
    let scrollThreshold = siteNav.classList.contains('scrolled') ? 16 : 96;
    if (window.scrollY > scrollThreshold) {
        siteNav.classList.add('scrolled');
    } else {
        siteNav.classList.remove('scrolled');
    }
    setTimeout(checkNavHeight, 200);
}

// Apply transparency effect to nav
function handleNavScrollTransparency() {
    let scrollThreshold = siteNav.classList.contains('scrolled') ? 16 : 96;
    if (window.scrollY > scrollThreshold) {
        siteNav.classList.remove('nav-transparent');
    } else {
        siteNav.classList.add('nav-transparent');
    }
}

// Apply event listeners to handle nav sizing and scrolling effects
window.addEventListener('scroll', handleNavScrollSizing);
window.addEventListener('resize', checkNavHeight);
screen.orientation.addEventListener('change', () => {
    // Wait for CSS transitions to complete then check nav height
    setTimeout(checkNavHeight, 200);
});
if (siteNav.classList.contains('nav-transparent')) {
    window.addEventListener('scroll', handleNavScrollTransparency);
}

// Check nav height at page load
setTimeout(() => {
    checkNavHeight();
    updateScrollPadding();
    updateBodyPadding();
}, 200);

// filter range sliders
document.addEventListener("DOMContentLoaded", function() {
    const rangeSliders = document.querySelectorAll(".filter-range-slider");
    if (rangeSliders) {
        for (let rangeSlider of rangeSliders) {
            let sliderElement = rangeSlider.querySelector(".filter-slider");
            let hiddenInputEl = sliderElement
                .closest(".slider-wrapper")
                .querySelector('input[type="hidden"]');
            let filterMin = rangeSlider.querySelector(".filter-min");
            let filterMax = rangeSlider.querySelector(".filter-max");
            let prefix = sliderElement.dataset.prefix;
            let suffix = sliderElement.dataset.suffix;
            // Initialize slider, parent select text on load
            filterMin.textContent = prefix + sliderElement.value1.toLocaleString() + suffix;
            filterMax.textContent = prefix + sliderElement.value2.toLocaleString() + suffix;
            // If we have filter options selected, set UI text to match
            if (sliderElement.value1 !== sliderElement.min || sliderElement.value2 !== sliderElement.max) {
                setFilterValue(sliderElement, hiddenInputEl);
                filterMin.textContent = prefix + sliderElement.value1.toLocaleString() + suffix;
                filterMax.textContent = prefix + sliderElement.value2.toLocaleString() + suffix;
            }
            // Update slider UI on change
            sliderElement.addEventListener("change", (evt) => {
                let value1 = evt.detail.value1;
                let value2 = evt.detail.value2;
                filterMin.textContent = prefix + value1.toLocaleString() + suffix;
                filterMax.textContent = prefix + value2.toLocaleString() + suffix;
            });
            // Update filter on change (DEBOUNCED because this change event fires rapidly).
            sliderElement.addEventListener(
                "change",
                debounce((e) => {
                    setFilterValue(sliderElement, hiddenInputEl);
                    // Avoid multiple change events on reset
                    if (!window.filterReset) {
                        hiddenInputEl.dispatchEvent(new Event("change"));
                    }
                }, 400),
            );
        }
    }
});
// Set filter input with values from sliders
window.setFilterValue = function(sliderEl, hiddenInputEl) {
    let low = sliderEl.value1;
    let high = sliderEl.value2;
    if (hiddenInputEl) {
        let value = `%${low}-${high}`;
        hiddenInputEl.value = value;
    }
};
// Reset values to min and max for sliders, revert label text content to default
window.resetSliderUi = function(sliderEl) {
    sliderEl.value1 = sliderEl.min;
    sliderEl.value2 = sliderEl.max;
};
